import UsersAutocomplete, { OptionType } from "../../../common/controls/UsersAutocomplete";
import React from "react";
import createCustomEvent from "../../../common/utils/createCustomEvent";
import * as Guid from "../../../common/utils/Guid";

export interface IProps {
	refControl: string,
	filter: string,
	filterGroup: string,
	errorText: string,
	maxRows: number,
	name: string,
	onSet?: (value: OptionType) => void,
	counters: string,
}

export default function UserCombobox(props: IProps) {
	const [value, setValue] = React.useState<OptionType>(null);
	const [filterGroup, setFilterGroup] = React.useState<string>();

	const idControlRef = React.useRef<HTMLInputElement>();
	const labelControlRef = React.useRef<HTMLInputElement>();
	const groupIdControlRef = React.useRef<HTMLInputElement>();

	React.useEffect(() => {
		idControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_id']");
		labelControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_label']");
		if (props.filterGroup) {
			groupIdControlRef.current = document.getElementById(props.filterGroup) as HTMLInputElement;

			if (!groupIdControlRef.current) {
				groupIdControlRef.current = document.getElementById(props.filterGroup + "_Id") as HTMLInputElement;
			}

			if (groupIdControlRef.current) {
				let currentGroupId = groupIdControlRef.current?.value ?? "";
				if (currentGroupId === Guid.Empty) {
					currentGroupId = "";
				}

				setFilterGroup(currentGroupId);
				groupIdControlRef.current.addEventListener("change", (e) => {
					handleGroupChange(e);
				}, false);
			}
			else
				console.warn('No input with id "' + props.filterGroup + '"');
		}

		if (idControlRef.current.value) {
			let newV = {
				value: idControlRef.current.value,
				label: labelControlRef.current.value,
			}

			setValue(newV);
			if (props.onSet)
				props.onSet(newV);
		}
	}, []);

	function handleGroupChange(e) {
		idControlRef.current.value = "";
		labelControlRef.current.value = "";
		setValue(null);

		let currentGroupId = e.target.value;
		if (currentGroupId === Guid.Empty) {
			currentGroupId = "";
		}

		setFilterGroup(currentGroupId);

		if (props.onSet)
			props.onSet(null);
	}

	let counter = props.counters;
	if (!counter) {
		switch (props.name) {
			case "Executor":
				counter = "ExecutorInIssuesCounter"
				break;
			case "AssignedTo":
				counter = "AssignedInIssuesCounter"
				break;
			case "Coordinator":
				counter = "CoordinatorInIssuesCounter"
				break;
		}
	}

	return <UsersAutocomplete
		className="qd-combocoxs-control"
		maxRows={props.maxRows}
		filterGroup={filterGroup}
		filter={props.filter}
		error={!!props.errorText}
		helperText={props.errorText}
		value={value}
		onChange={(v) => {
			setValue(v);

			idControlRef.current.value = v?.value ?? "";
			labelControlRef.current.value = v?.label ?? "";

			let event = createCustomEvent("change");
			idControlRef.current.dispatchEvent(event);

			if (props.onSet)
				props.onSet(v);
		}}
		counter={counter}
	/>
}